/**
 * This file is just a placeholder file for you to add any javascript that you may want to have run within the portal dashboard
 *
 * Technically speaking though, this JS file will be included on all pages so you must code accordingly.
 */

console.log('Limelyte demo of dashboard javascript loaded!');
